
<div class="row">
  <div class="col-md-12">
    <div class="card">
     
      <div class="card-body padding-top-0px padding-bottom-0px">
      
        <div class="row">
          <div class="col-md-12 text-align-left">
            <label class="margin-bottom-0px f2">Semen Data Analysis</label>
          </div>
        </div>
        <div class="table-component margin-bottom-0px">
          <div class="table-responsive">
            <table class="table table-striped margin-left-zero width-50-new">
              <tr>

                <th class="font-weight-normal td-padding-tb background-primary">

                </th>

                <th class="font-weight-normal td-padding-tb background-primary">
                  (Day1)
                </th>
                <th class="font-weight-normal td-padding-tb background-primary">

                </th>
              </tr>
              <tr>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">

                </th>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  Pre-Wash
                </th>
                <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                  Post-Wash
                </th>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Volume(ml)
                </td>
                <td class="td-padding-tb">
                  2.5
                </td>
                <td class="td-padding-tb">
                  0.5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  60
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Active Progressive Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  10
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Cellular Debris(mil/ml)
                </td>
                <td class="td-padding-tb">
                  ++
                </td>
                <td class="td-padding-tb">
                  ++
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Method of Preperation
                </td>
                <td class="td-padding-tb">
                  DG
                </td>
                <td class="td-padding-tb">
                  DG
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Incubation Time(In Min)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  45
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motile Sperm Count(mil/ml)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  5
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Motility(%)
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb">
                  60
                </td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Notes
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Side Observed
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Catheter Load Time
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
              <tr>

                <td class="td-padding-tb">
                  Catheter Loaded By
                </td>
                <td class="td-padding-tb"></td>
                <td class="td-padding-tb"></td>
              </tr>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>



